var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('ProjectOverviewBody',[_c('ProjectOverview',{attrs:{"title":"Digrab","image":"digrab/Digrab_Logo.png","description":"In Digrab you play as a Space Soldier who has crashed on an asteroid. Your ship is under dozens of rocks and your ennemies are still shooting at you. Dig for your ship while protecting yourself from the incomming missiles !","tags":['C#', 'Unity', '2D'],"timeline":"August - September 2018","team":"1 Game Designer & 1 Game Art","keypoints":[
          'First 2D game on Unity',
          'Made all the code',
          'Art and Sound integration'
      ],"categories":[
          '2D',
          'C#',
          'Unity'
      ]}}),_c('ProjectOverviewVideo',{attrs:{"source":"digrab/Digrab_Showreel.webm","thumbnail":"digrab/Digrab_Showreel_Thumbnail.jpg"}}),_c('ProjectOverviewCarrousel',{attrs:{"images":[
        'digrab/Digrab_Carrousel_1.png',
        'digrab/Digrab_Carrousel_2.png',
        'digrab/Digrab_Carrousel_3.png'
    ]}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }